import { render, staticRenderFns } from "./PostLayout.vue?vue&type=template&id=38691d58&"
import script from "./PostLayout.vue?vue&type=script&lang=js&"
export * from "./PostLayout.vue?vue&type=script&lang=js&"
import style0 from "./PostLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports